export default __webpack_public_path__ + "static/media/The Shield of Chaos.5e4de69e.jpg";